export default "__VITE_ASSET__Bq84TOBh__"